import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import DataTable, { MUIDataTableOptions } from "mui-datatables";
import * as Dati from "../../../Dati";
import { _TableLoader } from "../../components/";
import { GetUsersListColumns } from "./UsersListColumns";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    tableWrapper: {
        marginTop: spacing(4),
        position: "relative"
    }
}));

interface IUsersListTableProps {
    Data: Dati.CRisAPIPagineUtenti | undefined;
    Options: MUIDataTableOptions;
    IsLoading: boolean;
}

export const _UsersListTable: React.FC<IUsersListTableProps> = React.memo(({ Data, Options, IsLoading }) => {
    const classes = useStyles();

    return (
        <Box className={classes.tableWrapper}>
            {IsLoading && <_TableLoader />}
            <DataTable title="" data={Data?.Dati || []} columns={GetUsersListColumns()} options={Options} />
        </Box>
    );
});



// WEBPACK FOOTER //
// ./src/inar2/components/UsersList/UsersListTable.tsx